import { gql } from '@apollo/client';
import { PageInfoFragment } from '../fragments';
import { WorkspaceFieldsFragment } from './fragments';

export const WORKSPACES_LIST = gql`
  query workspaceList(
    $pagination: Pagination!
    $includes: [ID!]!
    $term: String
  ) {
    workspaceList(pagination: $pagination, includes: $includes, term: $term) {
      entities {
        id
        name
      }
      pageInfo {
        ...PageInfoFields
      }
    }
  }
  ${PageInfoFragment}
`;

export const GET_WORKSPACE = gql`
  query getWorkspace($id: ID!, $withLastViewedAt: Boolean = true) {
    workspace(id: $id) {
      ...WorkspaceEntity
      main {
        id
        lastViewedAt @include(if: $withLastViewedAt)
      }
    }
  }
  ${WorkspaceFieldsFragment}
`;
